module.exports = __webpack_public_path__ + "media/forge_burn.c9a40a0a.mp4";